import { AxiosInstance } from 'axios';
import {
  PermissionManagerServiceType,
  initPermissionManagerService,
} from '../../../../pages/SettingsModule/pages/ACL/Pages/PermissionPage/api';
import { RoleServiceModel, initRoleService } from './RoleService';
import { UserServiceModel, initUserService } from './UserService';
import { PermissionServiceModel, initPermissionService } from './permissionService';

export interface AclServiceModel {
  permission: PermissionServiceModel;
  user: UserServiceModel;
  role: RoleServiceModel;
  permissionManager: PermissionManagerServiceType;
}

export const initAclService = (axios: AxiosInstance): AclServiceModel => ({
  permissionManager: initPermissionManagerService(axios),
  permission: initPermissionService(axios),
  user: initUserService(axios),
  role: initRoleService(axios),
});
